// src/comps/ChatAgentButton.js
// Floating Action Button that opens/closes the AI Chat Agent
import React, { useState, useEffect, useCallback } from "react";
import ChatWidget from "./ChatWidget";
import "./chatAgentStyles.css";

export default function ChatAgentButton() {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  // Keyboard shortcut: Ctrl+K to toggle
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        toggle();
      }
      // Escape to close
      if (e.key === "Escape" && open) {
        setOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, toggle]);

  return (
    <>
      {/* Floating Action Button */}
      <button
        className="chat-fab"
        onClick={toggle}
        title="AI Assistant (Ctrl+K)"
        style={{ display: open ? "none" : "flex" }}
      >
        🤖
        {/* Uncomment below for unread badge */}
        {/* <span className="fab-badge">1</span> */}
      </button>

      {/* Chat Panel */}
      <ChatWidget open={open} onClose={() => setOpen(false)} />
    </>
  );
}

